import React, { useState, useEffect } from "react";
import styles from "../assets/css/UserList.module.css";
import { BlockToggle } from "./UsersList";
import { defaultProfile, togleA, togleB, view } from "../assets/img";
import { NavLink, useNavigate } from "react-router-dom";
import common from "../assets/css/common.module.css";
import { Loader } from "../../components/Loader";
import { Pagination } from "../Common";
import { postData1 } from "../../services";

export const Inspection = () => {
  const navigate = useNavigate();
  const [inspectList, setInspectList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [perPage, setPerPage] = useState(8);
  const [paging, setPaging] = useState({});

  const [prevPage, setPrevPage] = useState(1);

  // Sorting state variables
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Function to handle sorting
  const handleSort = (field) => {
    const newSortOrder = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
  };

  useEffect(() => {
    (async () => {
      const config = { _page: currPage, _limit: 8 };  // Don't include _sort and _order for now
      const res = await postData1("admin/inspection_list/", config, true, true);
      const sortedData = res?.data?.data || [];

      // Client-side sorting (if backend doesn't support sorting)
      if (sortField) {
        sortedData.sort((a, b) => {
          const aValue = a[sortField];
          const bValue = b[sortField];
          if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
          if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
          return 0;
        });
      }

      setInspectList(sortedData);
      setPaging({
        total: res?.data?.total,
        total_pages: res?.data?.total_pages,
      });
      setLoader(false);
    })();
  }, [currPage, perPage, sortField, sortOrder]);

  const handleView = (e, data) => {
    navigate("/admin/manageinspection/view/", { state: data });
  };

  // Function to determine the sort icon
  const getSortIcon = (field) => {
    if (sortField === field) {
      return sortOrder === "asc" ? "↑" : "↓";
    }
    return "";
  };

  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>INSPECTION MANAGEMENT</h1>
      </div>
      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span onClick={() => handleSort("id")}>
            INSPECT ID {getSortIcon("id")}
          </span>
          <span onClick={() => handleSort("product")}>
            PRODUCT {getSortIcon("product")}
          </span>
          <span onClick={() => handleSort("buyer_firstname")}>
            BUYER {getSortIcon("buyer_firstname")}
          </span>
          <span onClick={() => handleSort("seller_firstname")}>
            SELLER {getSortIcon("seller_firstname")}
          </span>
          <span onClick={() => handleSort("inspection_status")}>
            STATUS {getSortIcon("inspection_status")}
          </span>
          <span>DETAIL</span>
        </div>

        {inspectList?.map((data, index) => {
          return (
            <div className={styles.itemData} key={index}>
              <span>{data?.id}</span>
              <span>{data?.product}</span>
              <span>{data?.buyer_firstname}</span>
              <span>{data?.seller_firstname}</span>
              <span>
                <span className={common.customStyle}>
                  {data?.inspection_status === 1
                    ? "Pending"
                    : data?.inspection_status === 2
                    ? "Canceled"
                    : data?.inspection_status === 3
                    ? "Completed"
                    : ""}
                </span>
              </span>

              <span
                onClick={(e) => handleView(e, data)}
                style={{ cursor: "pointer" }}
              >
                View
              </span>
            </div>
          );
        })}
      </div>
      <Pagination
        total={paging?.total}
        perPage={perPage}
        currPage={currPage}
        setCurrPage={setCurrPage}
        prevPage={prevPage}
        tPage={paging?.total_pages}
        updatePage={updatePage}
        setPerPage={setPerPage}
      />

      {loader && <Loader />}
    </section>
  );
};
